import {
  ImagesMainBannerApril2025BowmoreSelectionWebp,
  ImagesMainBannerApril2025BottlesOfTheMonthWebp,
} from '@/assets/images_main-banner_april-2025.assets';
import { PrimaryButtonLink } from '@/components/common/PrimaryButton';
import useTypedTranslation from '@/hooks/useTypedTranslation';
import { IndexEnum } from '@/types/translations/IndexEnum';
import Image from 'next/image';
import { useRouter } from 'next/router';
export function BowmoreSelectionMainBannerApril2025() {
  const { translate } = useTypedTranslation<IndexEnum>('index');
  return (
    <div className="col-12 tw-relative tw-flex tw-h-[390px] tw-items-center tw-justify-center tw-overflow-hidden tw-rounded-[30px] max-nine:tw-h-[320px] max-nine:tw-rounded-none">
      <div className="tw-flex tw-h-full tw-w-full tw-items-center tw-justify-center max-nine:tw-px-4 max-nine:tw-backdrop-blur-sm max-nine:tw-backdrop-brightness-50">
        <div className="tw-flex tw-flex-col max-nine:tw-items-center nine:tw-pr-40">
          <h2 className="tw-relative tw-m-0 tw-flex tw-max-w-[500px] tw-flex-col tw-pb-4 tw-text-left tw-font-prata tw-text-4xl tw-leading-[1.3] tw-text-white tw-opacity-90 max-xl:tw-text-4xl max-nine:tw-max-w-[300px] max-nine:tw-text-center max-nine:tw-text-2xl max-nine:tw-leading-[1.2]">
            {translate(IndexEnum['bowmore_selection_april_2025.title'])}
            <hr
              className="tw-absolute tw-bottom-0 tw-m-0 tw-h-1 tw-w-[100%] tw-rounded-full tw-border-t-0 tw-border-none tw-bg-custom-gold tw-p-0 tw-opacity-100"
              aria-hidden="true"
            />
          </h2>
          <div>
            <p className="tw-mb-6 tw-max-w-[500px] tw-pt-4 tw-text-left tw-text-white tw-opacity-90 max-nine:tw-m-auto max-nine:tw-max-w-[280px] max-nine:tw-pb-2 max-nine:tw-text-center max-nine:tw-text-sm">
              {translate(IndexEnum['bowmore_selection_april_2025.text'])}
            </p>
            <PrimaryButtonLink
              href="/brands/Bowmore"
              white={true}
              className="tw-px-12 tw-text-main max-nine:tw-flex max-nine:tw-items-center max-nine:tw-justify-center max-nine:tw-px-6 max-nine:tw-text-sm"
            >
              {translate(IndexEnum['bowmore_selection_april_2025.button'])}
            </PrimaryButtonLink>
          </div>
        </div>
      </div>
      <Image
        src={ImagesMainBannerApril2025BowmoreSelectionWebp}
        priority={true}
        alt="Bowmore Selection"
        className="tw-absolute tw-inset-0 -tw-z-10 tw-h-full tw-w-full tw-rounded-[30px] tw-object-cover"
      />
    </div>
  );
}
export function BottlesOfTheMonthMainBannerApril2025() {
  const { translate } = useTypedTranslation<IndexEnum>('index');
  const { locale } = useRouter();
  return (
    <div className="col-12 tw-relative tw-flex tw-h-[390px] tw-items-center tw-justify-between tw-overflow-hidden tw-rounded-[30px] max-nine:tw-h-[320px] max-nine:tw-rounded-none">
      <div className="tw-ml-auto tw-flex tw-h-full tw-basis-3/5 tw-items-center tw-justify-end max-xl:tw-basis-2/4 max-nine:tw-basis-full max-nine:tw-justify-center max-nine:tw-px-4 max-nine:tw-backdrop-blur-sm max-nine:tw-backdrop-brightness-50">
        <div className="tw-flex tw-flex-col tw-gap-[20px] tw-pr-[80px] tw-pt-[20px] max-nine:tw-pr-0 max-nine:tw-text-center max-md:tw-w-full">
          <h2 className="tw-m-0 tw-ml-auto tw-flex tw-w-fit tw-flex-col tw-border-4 tw-border-l-0 tw-border-r-0 tw-border-t-0 tw-border-solid tw-border-custom-gold tw-pb-4 tw-text-right tw-font-prata tw-text-5xl tw-text-black max-xl:tw-text-4xl max-nine:tw-relative max-nine:tw-mx-auto max-nine:tw-max-w-[300px] max-nine:tw-border-b-0 max-nine:tw-text-center max-nine:tw-text-2xl max-nine:tw-leading-[1.2] max-nine:tw-text-white max-md:tw-w-full">
            {translate(IndexEnum['bottles_of_the_month_april_2025.bottles_of_the_month'])}
            <hr
              className="tw-hidden max-nine:tw-absolute max-nine:tw-bottom-0 max-nine:tw-m-0 max-nine:tw-block max-nine:tw-h-1 max-nine:tw-w-full max-nine:tw-rounded-full max-nine:tw-border-t-0 max-nine:tw-border-none max-nine:tw-bg-custom-gold max-nine:tw-p-0 max-nine:tw-opacity-100"
              aria-hidden="true"
            />
          </h2>
          <div className="tw-flex tw-flex-col tw-items-end max-nine:tw-items-center max-md:tw-w-full">
            <p className="tw-ml-auto tw-max-w-[500px] tw-text-right tw-text-sm tw-text-black max-nine:tw-m-auto max-nine:tw-mb-6 max-nine:tw-pb-2 max-nine:tw-text-center max-nine:tw-text-white max-md:tw-w-full">
              {translate(
                IndexEnum['bottles_of_the_month_april_2025.bottles_of_the_month_subtitle']
              )}
            </p>
            <PrimaryButtonLink
              href={`/collections/top-10-whiskies-of-april-2025-${locale}`}
              white={true}
              className="tw-ml-auto tw-px-12 tw-text-main max-nine:tw-mx-auto max-nine:tw-max-w-44 max-nine:tw-px-6 max-nine:tw-text-sm"
            >
              {translate(IndexEnum['bottles_of_the_month_april_2025.explore_our_collection'])}
            </PrimaryButtonLink>
          </div>
        </div>
      </div>
      <Image
        src={ImagesMainBannerApril2025BottlesOfTheMonthWebp}
        priority={true}
        alt="Bottles of the Month"
        className="tw-absolute tw-inset-0 -tw-z-10 tw-h-full tw-w-full tw-rounded-[30px] tw-object-cover"
      />
    </div>
  );
}
